import React, {useEffect, useState} from "react";
import {SdfBox} from '@synerg/react-components';
import {isEmpty, xor} from "lodash";

export const ReviewScopeChangesStep = (props = {}) => {
    const {isB2bScopes, data, preSelectedScopes = [], setScopesUpdated} = props;

    const [currentCononicalList, setCurrentCononicalList] = useState([]);
    const [currentSubscribeList, setCurrentSubscribeList] = useState([]);
    const [proposedCononicalList, setProposedCononicalList] = useState([]);
    const [proposedSubscribeList, setProposedSubscribeList] = useState([]);

    useEffect(() => {
        setScopesUpdated(
            !isEmpty(
                xor(
                    preSelectedScopes,
                    isB2bScopes ? data.b2bApplicationScopes : data.b2cApplicationScopes
                )
            )
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [preSelectedScopes, data]);

    useEffect(() => {
        if (Array.isArray(preSelectedScopes) && preSelectedScopes.length > 0) {
            setCurrentCononicalList(
                preSelectedScopes.filter(
                    (item) => !item.includes("eventnotify.subscribe")
                )
            );
            setCurrentSubscribeList(
                preSelectedScopes.filter((item) =>
                    item.includes("eventnotify.subscribe")
                )
            );
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [preSelectedScopes]);

    useEffect(() => {
        if (Object.keys(data).length > 0) {
            if (isB2bScopes) {
                if (
                    Array.isArray(data.b2bApplicationScopes) &&
                    data.b2bApplicationScopes.length > 0
                ) {
                    setProposedCononicalList(
                        data.b2bApplicationScopes.filter(
                            (item) => !item.includes("eventNotify.subscribe")
                        )
                    );
                    setProposedSubscribeList(
                        data.b2bApplicationScopes.filter((item) =>
                            item.includes("eventNotify.subscribe")
                        )
                    );
                }
            } else {
                if (
                    Array.isArray(data.b2cApplicationScopes) &&
                    data.b2cApplicationScopes.length > 0
                ) {
                    setProposedCononicalList(
                        data.b2cApplicationScopes.filter(
                            (item) => !item.includes("eventNotify.subscribe")
                        )
                    );
                    setProposedSubscribeList(
                        data.b2cApplicationScopes.filter((item) =>
                            item.includes("eventNotify.subscribe")
                        )
                    );
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    // const getBoxWidth = async () => {
    //     const container = await document.getElementById('subscribed-events');
    //     if (container) {
    //         return container.offsetWidth || 111;
    //     }
    //     return 111;
    // }

    const getStringCount = (item) => {
        if(item) {
            return item.length <= 111;
        }
        return false;
    }

    const getNewStringHtml = (strTxt) => {
        for (let i = 111; i >= 0; i--) {
            if (strTxt[i] === '.' || strTxt[i] === '/') {
                return (<div>{strTxt.slice(0, i)}<br/>.{strTxt.slice(i + 1, strTxt.length)}</div>)
            }
        }
        return strTxt;
    }

    return (
        <div className="w-full">
            <div className="text-heading-05 font-bold">
                Review {isB2bScopes ? "B2B" : "B2C"} Scope Changes
            </div>
            <div className="text-heading-04 font-bold">
                API canonicals and event notifications
            </div>

            <div className="text-heading-05 font-bold mt-12">
                Current ({preSelectedScopes && preSelectedScopes.length})
            </div>
            <div className="text-body-02 color-grey">
                Scope as it exists in CAR today
            </div>
            <SdfBox variant="bordered" className="mt-6">
                <div className="text-heading-03 font-bold mb-3">
                    API Canonical ({currentCononicalList && currentCononicalList.length})
                </div>
                {currentCononicalList &&
                    currentCononicalList.map((item, index) => (
                        (getStringCount(item) ?
                                <div className="text-md mb-2" key={index}>{item}</div>
                                :
                                <div key={index}>{getNewStringHtml(item)}</div>
                        )
                    ))}
            </SdfBox>
            <SdfBox variant="bordered" className="mt-2">
                <div className="text-heading-03 font-bold mb-3">
                    Subscribed Event Notifications (
                    {currentSubscribeList && currentSubscribeList.length})
                </div>

                {currentSubscribeList &&
                    currentSubscribeList.map((item, index) => (
                        (getStringCount(item) ?
                                <div className="text-md mb-2" key={index}>{item}</div>
                                :
                                <div key={index}>{getNewStringHtml(item)}</div>
                        )
                    ))}
            </SdfBox>

            <div className="text-heading-05 font-bold mt-8">
                Proposed (
                {isB2bScopes
                    ? (Array.isArray(data.b2bApplicationScopes) &&
                        data.b2bApplicationScopes.length) ||
                    0
                    : (Array.isArray(data.b2cApplicationScopes) &&
                        data.b2cApplicationScopes.length) ||
                    0}
                )
            </div>
            <div className="text-body-02 color-grey">Proposed changes to scope</div>
            <SdfBox variant="bordered" className="mt-6">
                <div className="text-heading-03 font-bold mb-3">
                    API Canonical ({proposedCononicalList && proposedCononicalList.length}
                    )
                </div>

                {proposedCononicalList &&
                    proposedCononicalList.map((item, index) => (
                        (getStringCount(item) ?
                                <div className="text-md mb-2" key={index}>{item}</div>
                                :
                                <div key={index}>{getNewStringHtml(item)}</div>
                        )
                    ))}
            </SdfBox>
            <SdfBox variant="bordered" className="mt-2" id="subscribed-events">
                <div className="text-heading-03 font-bold mb-3">
                    Subscribed Event Notifications (
                    {proposedSubscribeList && proposedSubscribeList.length})
                </div>
                {proposedSubscribeList &&
                    proposedSubscribeList.map((item, index) => (
                        (getStringCount(item) ?
                                <div className="text-md mb-2" key={index}>{item}</div>
                                :
                                <div key={index}>{getNewStringHtml(item)}</div>
                        )
                ))}
            </SdfBox>
        </div>
    );
};
